(() => {
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-goyo-ajax-cart]');
    if (!form) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"][name="add"]');
    const error = form.querySelector('[data-goyo-cart-error]');
    const formData = new FormData(form);
    formData.set('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
    formData.set('sections_url', window.location.pathname);
    button?.setAttribute('aria-disabled', 'true');
    if (button) button.disabled = true;
    button?.classList.add('loading');
    if (error) { error.hidden = true; error.textContent = ''; }
    try {
      const response = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add this item.');
      drawer.setActiveElement?.(button);
      drawer.renderContents(state);
    } catch (requestError) {
      if (error) { error.textContent = requestError.message; error.hidden = false; }
    } finally {
      button?.removeAttribute('aria-disabled');
      if (button) button.disabled = false;
      button?.classList.remove('loading');
    }
  });
})();
